<template>
  <transition name="fade" appear>
    <div v-if="student" class="student-on-top-popup">
      <div class="container">
        <StudentSoftkillsModal
          v-if="softskillsModalVisible"
          :current-note="currentNote"
          :softskills="softSkillList"
          :initial-data="student.softSkillsRatedByCustomer"
          :preload-soft-skills="preloadSoftSkills"
          :first-name="student.firstName"
          :gender="student.gender"
          @save-softskills="saveSoftSkills"
          @softskills-selected="onSoftSkillsSelected"
        />
        <StudentCommentModal
          v-if="commentModalVisible"
          :short-name="student.shortName"
          @save-comment="saveComment"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import StudentCommentModal from './StudentCommentModal';
import StudentSoftkillsModal from './studentSoftkillsModal';

export default {
  name: 'studentOnTopPopup',
  components: { StudentSoftkillsModal, StudentCommentModal },
  props: ['student', 'currentNote', 'softSkillList', 'preloadSoftSkills'],
  data() {
    return {
      commentModalVisible: false,
      softskillsModalVisible: false,
      form: {
        selectedSoftskills: [],
        comment: null,
      },
    };
  },
  watch: {
    currentNote: {
      handler() {
        this.onUpdateStudentOrCurrentNote();
      },
      immediate: true,
    },
  },
  methods: {
    onUpdateStudentOrCurrentNote() {
      this.softskillsModalVisible = true;
      this.commentModalVisible = false;
    },
    saveFeedback() {
      this.$emit('save-feedback', this.form);
    },
    saveSoftSkills(selectedSoftskills) {
      if (selectedSoftskills) {
        this.form.selectedSoftskills = [...selectedSoftskills];
      }
      this.softskillsModalVisible = false;

      if (this.student && this.currentNote < 4) {
        this.commentModalVisible = true;
      } else {
        this.saveFeedback();
      }
    },
    onSoftSkillsSelected(selectedSoftskills) {
      this.form.selectedSoftskills = [...selectedSoftskills];
      this.$emit('softskills-selected', selectedSoftskills);
    },
    saveComment(comment) {
      this.form.comment = comment;
      this.softskillsModalVisible = false;
      this.commentModalVisible = false;
      this.saveFeedback();
    },
  },
};
</script>

<style scoped>

</style>
